import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api-service';
import { ApiResponse } from '../../common/models/api-response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  loggedInUserDetails: any;

  private readonly loginUrl = 'Auth/login';
  private readonly userOrganizationsUrl = 'Auth/GetUserOrganizations';
  private readonly resetpasswordUrl = 'Organizations/resetpassword';
  private readonly verfiyEmailForResetPasswordUrl = 'Auth/ForgotPassword';
  private readonly verifyResetTokenUrl = 'Auth/VerifyResetToken';

  constructor(private apiService: ApiService) { }

  onAuthUser(payload: any) {
    return this.apiService.post(this.loginUrl, payload);
  }

  GetUserOrganizations(payload: any) {
    return this.apiService.get(this.userOrganizationsUrl, payload);
  }

  getUserDetails(userdDetails: any) {
    this.loggedInUserDetails = userdDetails;
  }

  resetpassword(payload: any): Observable<ApiResponse<any>> {
    return this.apiService.post(this.resetpasswordUrl, payload);
  }

  verfiyEmailForResetPassword(email: string, organizationId?: string) {
    let url = `${this.verfiyEmailForResetPasswordUrl}?Email=${email}`;
    if (organizationId) {
      url += `&OrganizationId=${organizationId}`;
    }
    return this.apiService.get<ApiResponse<any>>(url);
  }

  verifyResetToken(token: any): Observable<ApiResponse<string>> {
    return this.apiService.get(this.verifyResetTokenUrl + '?RawToken=' + token);
  }

}
